// extracted by mini-css-extract-plugin
module.exports = {"filters":"useIssuesFilters_filters__lniRg"};